import type { ModelDefinition } from "@/models.js";

export const anthropicModels = [
	{
		id: "claude-fable-5-1",
		name: "Claude Fable 5.1",
		description:
			"Anthropic's most capable model for demanding reasoning and long-horizon agentic work, extending Claude Fable 5 with stronger agentic coding, multistep research, and document work.",
		family: "anthropic",
		releasedAt: new Date("2026-09-01"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				midConversationSystem: true,
				externalId: "claude-fable-5-1",
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "0.25e-6",
				cacheWriteInputPrice: "12.5e-6",
				cacheWriteInputPrice1h: "20.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
			{
				test: "skip",
				providerId: "azure-anthropic",
				externalId: "claude-fable-5-1",
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "0.25e-6",
				cacheWriteInputPrice: "12.5e-6",
				cacheWriteInputPrice1h: "20.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-fable-5-1",
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "0.25e-6",
				cacheWriteInputPrice: "12.5e-6",
				cacheWriteInputPrice1h: "20.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				regions: [{ id: "global" }, { id: "us" }],
				supportedParameters: ["max_tokens", "effort"],
			},
		],
	},
	{
		id: "claude-fable-5",
		name: "Claude Fable 5",
		description: "Next generation intelligence for knowledge work and coding.",
		family: "anthropic",
		releasedAt: new Date("2026-06-09"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				midConversationSystem: true,
				externalId: "claude-fable-5",
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "1.0e-6",
				cacheWriteInputPrice: "12.5e-6",
				cacheWriteInputPrice1h: "20.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
			{
				test: "skip",
				providerId: "azure-anthropic",
				externalId: "claude-fable-5",
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "1.0e-6",
				cacheWriteInputPrice: "12.5e-6",
				cacheWriteInputPrice1h: "20.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-fable-5",
				inputPrice: "10.0e-6",
				outputPrice: "50.0e-6",
				cachedInputPrice: "1.0e-6",
				cacheWriteInputPrice: "12.5e-6",
				cacheWriteInputPrice1h: "20.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				regions: [{ id: "global" }, { id: "us" }],
				supportedParameters: ["max_tokens", "effort"],
			},
		],
	},
	{
		id: "claude-3-7-sonnet",
		name: "Claude 3.7 Sonnet",
		description:
			"Intelligent model with extended thinking for complex reasoning tasks.",
		family: "anthropic",
		releasedAt: new Date("2025-02-24"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-7-sonnet-latest",
				deactivatedAt: new Date("2026-07-07"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-3-7-sonnet-20250219-v1:0",
				deprecatedAt: new Date("2025-10-28"),
				deactivatedAt: new Date("2026-04-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "us-east-1" },
					{ id: "us-east-2" },
					{ id: "us-west-2" },
					{ id: "eu-central-1" },
					{ id: "eu-north-1" },
					{ id: "eu-west-1" },
					{ id: "eu-west-2" },
					{ id: "eu-west-3" },
				],
			},
		],
	},
	{
		id: "claude-3-5-haiku-20241022",
		name: "Claude 3.5 Haiku (2024-10-22)",
		description:
			"Fast, compact model for quick responses and efficient processing.",
		family: "anthropic",
		releasedAt: new Date("2024-10-22"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-5-haiku-20241022",
				inputPrice: "0.8e-6",
				outputPrice: "4.0e-6",
				cachedInputPrice: "0.08e-6",
				cacheWriteInputPrice: "1.0e-6",
				cacheWriteInputPrice1h: "1.6e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deprecatedAt: new Date("2025-12-19"),
				deactivatedAt: new Date("2026-02-19T17:00:00Z"),
			},
		],
	},
	{
		id: "claude-3-7-sonnet-20250219",
		name: "Claude 3.7 Sonnet (2025-02-19)",
		description:
			"Dated version of Claude 3.7 Sonnet with reasoning capabilities.",
		family: "anthropic",
		releasedAt: new Date("2025-02-19"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-7-sonnet-20250219",
				deactivatedAt: new Date("2026-07-07"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: true,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
		],
	},
	{
		id: "claude-3-5-sonnet-20241022",
		name: "Claude 3.5 Sonnet (2024-10-22)",
		description: "Previous generation Sonnet model for balanced performance.",
		family: "anthropic",
		releasedAt: new Date("2024-10-22"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-5-sonnet-20241022",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deactivatedAt: new Date("2025-10-28"),
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-3-5-sonnet-20241022-v2:0",
				deprecatedAt: new Date("2025-10-28"),
				deactivatedAt: new Date("2026-04-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "apac" },
					{ id: "us-east-1" },
					{ id: "us-east-2" },
					{ id: "us-west-2" },
					{ id: "eu-central-1" },
					{ id: "eu-west-1" },
					{ id: "eu-west-3" },
					{ id: "ap-northeast-1" },
					{ id: "ap-northeast-2" },
					{ id: "ap-southeast-1" },
				],
			},
		],
	},
	{
		id: "claude-2.1",
		name: "Claude 2.1",
		description: "Legacy Claude model, deprecated in 2025.",
		family: "anthropic",
		releasedAt: new Date("2023-11-21"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-2.1",
				inputPrice: "8.0e-6",
				outputPrice: "24.0e-6",
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				streaming: true,
				vision: false,
				tools: false,
				deprecatedAt: new Date("2025-06-15T00:00:00Z"),
				deactivatedAt: new Date("2025-07-21T16:00:00Z"),
			},
		],
	},
	{
		id: "claude-sonnet-4-20250514",
		name: "Claude Sonnet 4 (2025-05-14)",
		description: "Claude Sonnet 4 with enhanced reasoning and tool use.",
		family: "anthropic",
		releasedAt: new Date("2025-05-14"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-sonnet-4-20250514",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deactivatedAt: new Date("2026-06-15"),
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-20250514-v1:0",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				deactivatedAt: new Date("2026-06-15"),
			},
		],
	},
	{
		id: "claude-sonnet-4-5",
		name: "Claude Sonnet 4.5",
		description:
			"Latest Claude Sonnet with improved reasoning and extended thinking.",
		family: "anthropic",
		releasedAt: new Date("2025-09-29"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-sonnet-4-5",
				deprecatedAt: new Date("2026-10-30"),
				deactivatedAt: new Date("2026-11-24T17:00:00Z"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				maxOutput: 64000,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-5-20250929-v1:0",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "au" },
					{ id: "jp" },
				],
			},
			{
				test: "skip",
				providerId: "vertex-anthropic",
				externalId: "claude-sonnet-4-5",
				deactivatedAt: new Date("2026-11-30"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-sonnet-4-5-20250929",
		name: "Claude Sonnet 4.5 (2025-09-29)",
		description:
			"Latest Claude Sonnet with improved reasoning and extended thinking.",
		family: "anthropic",
		releasedAt: new Date("2025-09-29"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-sonnet-4-5-20250929",
				deprecatedAt: new Date("2026-10-30"),
				deactivatedAt: new Date("2026-11-24T17:00:00Z"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				maxOutput: 64000,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-5-20250929-v1:0",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "au" },
					{ id: "jp" },
				],
			},
		],
	},
	{
		id: "claude-sonnet-4-6",
		name: "Claude Sonnet 4.6",
		description:
			"Claude Sonnet 4.6 with advanced reasoning, extended thinking, and vision capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-02-17"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-sonnet-4-6",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-4-6",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "au" },
					{ id: "jp" },
					{ id: "eu-west-2" },
				],
			},
			{
				providerId: "vertex-anthropic",
				externalId: "claude-sonnet-4-6",
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-sonnet-5",
		name: "Claude Sonnet 5",
		description:
			"Claude Sonnet 5 with advanced reasoning, adaptive thinking, and vision capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-06-30"),
		providers: [
			{
				providerId: "anthropic",
				midConversationSystem: true,
				externalId: "claude-sonnet-5",
				inputPrice: "2.0e-6",
				outputPrice: "10.0e-6",
				cachedInputPrice: "0.2e-6",
				cacheWriteInputPrice: "2.5e-6",
				cacheWriteInputPrice1h: "4.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedToolChoices: ["auto", "none", "required", "function"],
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
				webSearch: true,
				webSearchPrice: "0.01",
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-5",
				inputPrice: "2.0e-6",
				outputPrice: "10.0e-6",
				cachedInputPrice: "0.2e-6",
				cacheWriteInputPrice: "2.5e-6",
				cacheWriteInputPrice1h: "4.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: false,
				regions: [{ id: "global" }, { id: "us" }],
				supportedToolChoices: ["auto", "required", "function"],
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
			},
			{
				providerId: "azure-anthropic",
				externalId: "claude-sonnet-5",
				// Introductory pricing through 2026-08-31 (input $2, output $10 per 1M);
				// standard rate is input $3, output $15.
				inputPrice: "2.0e-6",
				outputPrice: "10.0e-6",
				cachedInputPrice: "0.2e-6",
				cacheWriteInputPrice: "2.5e-6",
				cacheWriteInputPrice1h: "4.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedToolChoices: ["auto", "none", "required", "function"],
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
			},
			{
				providerId: "vertex-anthropic",
				midConversationSystem: true,
				externalId: "claude-sonnet-5",
				inputPrice: "2.0e-6",
				outputPrice: "10.0e-6",
				cachedInputPrice: "0.2e-6",
				cacheWriteInputPrice: "2.5e-6",
				cacheWriteInputPrice1h: "4.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedToolChoices: ["auto", "none", "required", "function"],
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
			},
		],
	},
	{
		id: "claude-sonnet-5-5",
		name: "Claude Sonnet 5.5",
		description:
			"Claude Sonnet 5.5 is Anthropic's best combination of speed and intelligence, with adaptive thinking and vision capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-09-28"),
		providers: [
			{
				providerId: "anthropic",
				midConversationSystem: true,
				externalId: "claude-sonnet-5-5",
				inputPrice: "2.0e-6",
				outputPrice: "10.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "2.5e-6",
				cacheWriteInputPrice1h: "4.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				supportedToolChoices: ["auto", "none"],
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
				webSearch: true,
				webSearchPrice: "0.01",
			},
			{
				test: "skip",
				providerId: "azure-anthropic",
				externalId: "claude-sonnet-5-5",
				inputPrice: "2.0e-6",
				outputPrice: "10.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "2.5e-6",
				cacheWriteInputPrice1h: "4.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				supportedToolChoices: ["auto", "none"],
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-sonnet-5-5",
				inputPrice: "2.0e-6",
				outputPrice: "10.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "2.5e-6",
				cacheWriteInputPrice1h: "4.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				supportedParameters: ["max_tokens", "effort"],
				regions: [{ id: "global" }, { id: "us" }, { id: "eu" }],
			},
		],
	},
	{
		id: "claude-haiku-5-5",
		name: "Claude Haiku 5.5",
		description:
			"Claude Haiku 5.5 is Anthropic's fastest model for high-volume, latency-sensitive work such as classification, routing, extraction, and subagent tasks, with adaptive thinking and vision capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-10-07"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-haiku-5-5",
				inputPrice: "0.1e-6",
				outputPrice: "0.5e-6",
				cachedInputPrice: "0.01e-6",
				cacheWriteInputPrice: "0.125e-6",
				cacheWriteInputPrice1h: "0.2e-6",
				pricingTiers: [
					{
						name: "Up to 100K",
						upToTokens: 100000,
						inputPrice: "0.1e-6",
						outputPrice: "0.5e-6",
						cachedInputPrice: "0.01e-6",
						cacheWriteInputPrice: "0.125e-6",
						cacheWriteInputPrice1h: "0.2e-6",
					},
					{
						name: "Over 100K",
						upToTokens: Infinity,
						inputPrice: "0.5e-6",
						outputPrice: "2.5e-6",
						cachedInputPrice: "0.05e-6",
						cacheWriteInputPrice: "0.625e-6",
						cacheWriteInputPrice1h: "1.0e-6",
					},
				],
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				supportedToolChoices: ["auto", "none", "required", "function"],
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
				webSearch: true,
				webSearchPrice: "0.01",
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-haiku-5-5",
				inputPrice: "0.1e-6",
				outputPrice: "0.5e-6",
				cachedInputPrice: "0.01e-6",
				cacheWriteInputPrice: "0.125e-6",
				cacheWriteInputPrice1h: "0.2e-6",
				pricingTiers: [
					{
						name: "Up to 100K",
						upToTokens: 100000,
						inputPrice: "0.1e-6",
						outputPrice: "0.5e-6",
						cachedInputPrice: "0.01e-6",
						cacheWriteInputPrice: "0.125e-6",
						cacheWriteInputPrice1h: "0.2e-6",
					},
					{
						name: "Over 100K",
						upToTokens: Infinity,
						inputPrice: "0.5e-6",
						outputPrice: "2.5e-6",
						cachedInputPrice: "0.05e-6",
						cacheWriteInputPrice: "0.625e-6",
						cacheWriteInputPrice1h: "1.0e-6",
					},
				],
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				supportedToolChoices: ["auto", "required", "function"],
				supportedParameters: ["max_tokens", "effort", "tool_choice"],
				regions: [{ id: "global" }, { id: "us" }, { id: "eu" }],
			},
		],
	},
	{
		id: "claude-haiku-4-5",
		name: "Claude Haiku 4.5",
		description:
			"Fast, efficient model for high-volume, low-latency applications.",
		family: "anthropic",
		releasedAt: new Date("2025-10-15"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-haiku-4-5",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-haiku-4-5-20251001-v1:0",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "au" },
					{ id: "jp" },
				],
			},
			{
				providerId: "vertex-anthropic",
				externalId: "claude-haiku-4-5",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-haiku-4-5-free",
		name: "Claude Haiku 4.5 (Free)",
		description:
			"Free, fast, efficient model for high-volume, low-latency applications.",
		family: "anthropic",
		free: true,
		releasedAt: new Date("2025-10-15"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-haiku-4-5",
				// Retired: the free tier ran on our own Anthropic credentials, so it
				// was pure cost with no path to revenue. Onboarding's first call —
				// the last surface that needed a free model — now runs on a
				// platform-sponsored key against a cheap paid model instead.
				deactivatedAt: new Date("2026-08-10"),
				inputPrice: "0",
				outputPrice: "0",
				cachedInputPrice: "0",
				cacheWriteInputPrice: "0",
				cacheWriteInputPrice1h: "0",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "claude-haiku-4-5-20251001",
		name: "Claude Haiku 4.5 (2025-10-01)",
		description:
			"Fast, efficient model for high-volume, low-latency applications.",
		family: "anthropic",
		releasedAt: new Date("2025-10-15"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-haiku-4-5-20251001",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-haiku-4-5-20251001-v1:0",
				inputPrice: "1.0e-6",
				outputPrice: "5.0e-6",
				cachedInputPrice: "0.1e-6",
				cacheWriteInputPrice: "1.25e-6",
				cacheWriteInputPrice1h: "2.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 64000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "au" },
					{ id: "jp" },
				],
			},
		],
	},
	{
		id: "claude-opus-4-20250514",
		name: "Claude Opus 4 (2025-05-14)",
		description:
			"High-capability model for complex analysis and nuanced tasks.",
		family: "anthropic",
		releasedAt: new Date("2025-05-22"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-20250514",
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				cacheWriteInputPrice1h: "30.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deactivatedAt: new Date("2026-06-15"),
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-20250514-v1:0",
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				deactivatedAt: new Date("2026-06-15"),
			},
		],
	},
	{
		id: "claude-opus-4-1-20250805",
		name: "Claude Opus 4.1",
		description: "Updated Opus with vision support and 32K output.",
		family: "anthropic",
		releasedAt: new Date("2025-08-05"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-1-20250805",
				deactivatedAt: new Date("2026-08-05"),
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				cacheWriteInputPrice1h: "30.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				streaming: true,
				vision: true,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-1-20250805-v1:0",
				deprecatedAt: new Date("2026-07-08"),
				deactivatedAt: new Date("2026-10-20"),
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				streaming: true,
				vision: true,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [{ id: "us" }],
			},
		],
	},
	{
		id: "claude-3-5-sonnet-20240620",
		name: "Claude 3.5 Sonnet (Old)",
		description: "Original Claude 3.5 Sonnet with vision capabilities.",
		family: "anthropic",
		releasedAt: new Date("2024-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-5-sonnet-20240620",
				deactivatedAt: new Date("2025-10-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: true,
				tools: true,
			},
		],
	},
	{
		id: "claude-3-5-sonnet",
		name: "Claude 3.5 Sonnet",
		description:
			"Latest Claude 3.5 Sonnet with balanced speed and intelligence.",
		family: "anthropic",
		releasedAt: new Date("2024-06-20"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-5-sonnet-latest",
				deactivatedAt: new Date("2025-10-28"),
				inputPrice: "3.0e-6",
				outputPrice: "15.0e-6",
				cachedInputPrice: "0.3e-6",
				cacheWriteInputPrice: "3.75e-6",
				cacheWriteInputPrice1h: "6.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: undefined,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
		],
	},
	{
		id: "claude-3-5-haiku",
		name: "Claude 3.5 Haiku",
		description: "Fastest Claude model for instant responses at scale.",
		family: "anthropic",
		releasedAt: new Date("2024-10-22"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-5-haiku-latest",
				inputPrice: "0.8e-6",
				outputPrice: "4.0e-6",
				cachedInputPrice: "0.08e-6",
				cacheWriteInputPrice: "1.0e-6",
				cacheWriteInputPrice1h: "1.6e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
				deprecatedAt: new Date("2025-12-19"),
				deactivatedAt: new Date("2026-02-19T17:00:00Z"),
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-3-5-haiku-20241022-v1:0",
				deprecatedAt: new Date("2025-10-28"),
				deactivatedAt: new Date("2026-04-28"),
				inputPrice: "0.8e-6",
				outputPrice: "4.0e-6",
				cachedInputPrice: "0.08e-6",
				cacheWriteInputPrice: "1.0e-6",
				minCacheableTokens: 2048,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 8192,
				streaming: true,
				vision: false,
				tools: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "us-east-1" },
					{ id: "us-east-2" },
					{ id: "us-west-2" },
				],
			},
		],
	},
	{
		id: "claude-3-opus",
		name: "Claude 3 Opus",
		description: "Most capable Claude 3 model for expert-level tasks.",
		family: "anthropic",
		releasedAt: new Date("2024-03-04"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-3-opus-20240229",
				deactivatedAt: new Date("2026-01-05"),
				inputPrice: "15.0e-6",
				outputPrice: "75.0e-6",
				cachedInputPrice: "1.5e-6",
				cacheWriteInputPrice: "18.75e-6",
				cacheWriteInputPrice1h: "30.0e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 4096,
				streaming: true,
				vision: true,
				tools: true,
			},
		],
	},
	{
		id: "claude-3-haiku",
		name: "Claude 3 Haiku",
		description:
			"Compact Claude 3 model with vision for fast, affordable inference.",
		family: "anthropic",
		releasedAt: new Date("2024-03-04"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-haiku-20240307",
				inputPrice: "0.25e-6",
				outputPrice: "1.25e-6",
				cachedInputPrice: "0.03e-6",
				cacheWriteInputPrice: "0.3e-6",
				cacheWriteInputPrice1h: "0.5e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 4096,
				streaming: true,
				vision: true,
				tools: true,
				deprecatedAt: new Date("2025-07-14"),
				deactivatedAt: new Date("2025-10-14"),
			},
		],
	},
	{
		id: "claude-3-haiku-20240307",
		name: "Claude 3 Haiku (2024-03-07)",
		description:
			"Compact Claude 3 model with vision for fast, affordable inference.",
		family: "anthropic",
		releasedAt: new Date("2024-03-04"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-3-haiku-20240307",
				inputPrice: "0.25e-6",
				outputPrice: "1.25e-6",
				cachedInputPrice: "0.03e-6",
				cacheWriteInputPrice: "0.3e-6",
				cacheWriteInputPrice1h: "0.5e-6",
				minCacheableTokens: 1024,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 4096,
				streaming: true,
				vision: true,
				tools: true,
				deprecatedAt: new Date("2025-07-14"),
				deactivatedAt: new Date("2025-10-14"),
			},
		],
	},
	{
		id: "claude-opus-4-5-20251101",
		name: "Claude Opus 4.5",
		description:
			"Claude Opus 4.5 is Anthropic's advanced reasoning model built for complex coding, agentic workflows, and long-running tasks with improved multimodal performance, efficiency, and reliability.",
		family: "anthropic",
		releasedAt: new Date("2025-11-24"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-5-20251101",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-5-20251101-v1:0",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [{ id: "global" }, { id: "us" }, { id: "eu" }],
			},
			{
				test: "skip",
				providerId: "vertex-anthropic",
				externalId: "claude-opus-4-5",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 200000,
				maxOutput: 32000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMaxTokens: true,
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
			},
		],
	},
	{
		id: "claude-opus-4-6",
		name: "Claude Opus 4.6",
		description:
			"Claude Opus 4.6 is Anthropic's latest flagship model with advanced reasoning capabilities for complex coding, agentic workflows, and long-running tasks.",
		family: "anthropic",
		releasedAt: new Date("2026-02-05"),
		providers: [
			{
				test: "skip",
				providerId: "anthropic",
				externalId: "claude-opus-4-6",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				test: "skip",
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-6-v1",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "au" },
					{ id: "eu-west-2" },
				],
			},
			{
				test: "skip",
				providerId: "azure-anthropic",
				externalId: "claude-opus-4-6",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				// Foundry rejects `xhigh` on this model with a 400 listing the
				// supported levels as low/medium/high/max, unlike the newer Opus
				// deployments which accept it.
				reasoningEfforts: ["none", "low", "medium", "high", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
			},
			{
				test: "skip",
				providerId: "vertex-anthropic",
				externalId: "claude-opus-4-6",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["temperature", "max_tokens", "top_p", "effort"],
			},
		],
	},
	{
		id: "claude-opus-4-7",
		name: "Claude Opus 4.7",
		description:
			"Claude Opus 4.7 is Anthropic's latest flagship model with enhanced coding and vision capabilities, adaptive reasoning, and improved performance on complex agentic workflows.",
		family: "anthropic",
		releasedAt: new Date("2026-04-16"),
		providers: [
			{
				providerId: "anthropic",
				externalId: "claude-opus-4-7",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				// Adaptive thinking may skip thinking for simpler prompts, so reasoning content
				// is not guaranteed in every response.
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
				webSearch: true,
				webSearchPrice: "0.01", // $10 per 1000 searches
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-7",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "jp" },
					{ id: "au" },
				],
				supportedParameters: ["max_tokens", "effort"],
			},
			{
				providerId: "azure-anthropic",
				externalId: "claude-opus-4-7",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				// Foundry rejects `temperature` for this model ("`temperature` is
				// deprecated for this model"), so it is stripped from forwarded
				// requests along with `top_p`.
				supportedParameters: ["max_tokens", "effort"],
			},
			{
				providerId: "vertex-anthropic",
				externalId: "claude-opus-4-7",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
		],
	},
	{
		id: "claude-opus-4-8",
		name: "Claude Opus 4.8",
		description:
			"Claude Opus 4.8 is Anthropic's most capable model with state-of-the-art coding, reasoning, and agentic capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-05-28"),
		providers: [
			{
				providerId: "anthropic",
				midConversationSystem: true,
				externalId: "claude-opus-4-8",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
				webSearch: true,
				webSearchPrice: "0.01",
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-4-8",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				// `temperature` and `top_p` are deprecated for Opus 4.8 on Bedrock
				// and rejected with a 400, so they are excluded here to strip them
				// from forwarded requests. `effort` drives adaptive thinking via the
				// Bedrock Converse builder (output_config.effort).
				supportedParameters: ["max_tokens", "effort"],
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "jp" },
					{ id: "au" },
				],
			},
			{
				providerId: "azure-anthropic",
				externalId: "claude-opus-4-8",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
		],
	},
	{
		id: "claude-opus-5-5",
		name: "Claude Opus 5.5",
		description:
			"Claude Opus 5.5 is Anthropic's model for long-running agentic coding and knowledge work, with always-on adaptive thinking at a lower price than Claude Opus 5.",
		family: "anthropic",
		releasedAt: new Date("2026-09-22"),
		providers: [
			{
				providerId: "anthropic",
				midConversationSystem: true,
				externalId: "claude-opus-5-5",
				inputPrice: "4.0e-6",
				outputPrice: "20.0e-6",
				cachedInputPrice: "0.2e-6",
				cacheWriteInputPrice: "5.0e-6",
				cacheWriteInputPrice1h: "8.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
				webSearch: true,
				webSearchPrice: "0.01",
			},
			{
				test: "skip",
				providerId: "azure-anthropic",
				externalId: "claude-opus-5-5",
				inputPrice: "4.0e-6",
				outputPrice: "20.0e-6",
				cachedInputPrice: "0.2e-6",
				cacheWriteInputPrice: "5.0e-6",
				cacheWriteInputPrice1h: "8.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-5-5",
				inputPrice: "4.0e-6",
				outputPrice: "20.0e-6",
				cachedInputPrice: "0.2e-6",
				cacheWriteInputPrice: "5.0e-6",
				cacheWriteInputPrice1h: "8.0e-6",
				minCacheableTokens: 512,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				supportedParameters: ["max_tokens", "effort"],
				regions: [
					{ id: "global" },
					{ id: "us" },
					{ id: "eu" },
					{ id: "jp" },
					{ id: "au" },
				],
			},
		],
	},
	{
		id: "claude-opus-5",
		name: "Claude Opus 5",
		description:
			"Claude Opus 5 is Anthropic's model for complex agentic coding and enterprise work, with state-of-the-art reasoning and agentic capabilities.",
		family: "anthropic",
		releasedAt: new Date("2026-07-24"),
		providers: [
			{
				providerId: "anthropic",
				midConversationSystem: true,
				externalId: "claude-opus-5",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
				webSearch: true,
				webSearchPrice: "0.01",
			},
			{
				providerId: "aws-bedrock",
				externalId: "anthropic.claude-opus-5",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				// `temperature` and `top_p` are deprecated for Opus 5 on Bedrock
				// and rejected with a 400, so they are excluded here to strip them
				// from forwarded requests. `effort` drives adaptive thinking via the
				// Bedrock Converse builder (output_config.effort).
				supportedParameters: ["max_tokens", "effort"],
				// Opus 5 is provisioned on Bedrock in global/us/eu at launch; the
				// jp and au regions return 503 (not yet available) and are omitted
				// until Bedrock rolls the model out there.
				regions: [{ id: "global" }, { id: "us" }, { id: "eu" }],
			},
			{
				providerId: "azure-anthropic",
				externalId: "claude-opus-5",
				inputPrice: "5.0e-6",
				outputPrice: "25.0e-6",
				cachedInputPrice: "0.5e-6",
				cacheWriteInputPrice: "6.25e-6",
				cacheWriteInputPrice1h: "10.0e-6",
				minCacheableTokens: 4096,
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 128000,
				reasoning: true,
				reasoningEfforts: ["none", "low", "medium", "high", "xhigh", "max"],
				reasoningMode: "adaptive",
				reasoningOutput: "omit",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutputSchema: true,
				supportedParameters: ["max_tokens", "effort"],
			},
		],
	},
] as const satisfies ModelDefinition[];
